<template>
  <aw-drop
    :list="items"
    :list-item-key="itemKey"
    :drop-area-id="dropAreaId"
    class="BcTree__Wrapper"
    tag="ul"
    @drop-item="dropItem"
    :can-drop-item="canDropItem"
  >
    <template #default="{ item, index, dropAreaId }">
      <slot v-bind="{ item, index, dropAreaId, open, opened, toggle, attrs: $attrs }" />
    </template>
  </aw-drop>
</template>

<script>
import { mapStores } from 'pinia'
import bcFolderStore from '@/frontapp/store/bcFolder'
import FolderList from '../../mixins/FolderList'

export default {
  name: 'BcTree',
  emits: ['update:modelValue'],
  mixins: [FolderList],
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemKey: {
      type: String,
      required: false,
      default: 'id',
    },
    modelValue: {
      type: Object,
      required: false,
      default: () => {
        return {

        }
      }
    },
    dropAreaId: {
      type: String,
      default: null
    },
    parentBcFolderId: {
      type: Number,
      default: null
    },
    canDrop: {
      type: Boolean,
    }
  },
  computed: {
   ...mapStores(bcFolderStore),
    opened: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    toggle (key) {
      const opened = { ...this.opened }
      if (opened[key]) {
        delete opened[key]
      } else {
        opened[key] = true
      }
      this.opened = opened
    },
    open (key) {
      const opened = { ...this.opened }
      opened[key] = true
      this.opened = opened
    },
    canDropItem() {
      return this.canDrop
    }
  },
}
</script>